/**
 * @internal
 * Metadata used when processing word desktop lists
 */
export interface WordMetadata {
    readonly 'mso-level-number-format'?: string;
    readonly 'mso-level-start-at'?: string;
    readonly 'mso-level-text'?: string;
}
